module.exports = __webpack_public_path__ + "img/bj.5561ec95.svg";